import { render, staticRenderFns } from "./UserBillingDetail.vue?vue&type=template&id=36375da0&scoped=true"
import script from "./UserBillingDetail.vue?vue&type=script&lang=js"
export * from "./UserBillingDetail.vue?vue&type=script&lang=js"
import style0 from "./UserBillingDetail.vue?vue&type=style&index=0&id=36375da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36375da0",
  null
  
)

export default component.exports